<template>
  <div class="register auth-page">
    <van-nav-bar class="auth-nav" :title="$t('auth.register')">
      <template #left>
        <van-icon name="arrow-left" aria-label="Back" @click="back()" />
      </template>
    </van-nav-bar>

    <main class="auth-content">
      <VictoriaBrand compact />

      <section class="auth-form" aria-label="Registration form">
        <van-field
          v-model="username"
          clearable
          class="auth-field"
          autocomplete="username"
          :placeholder="$t('auth.username_place')"
        >
          <template #left-icon>
            <van-icon name="user-o" aria-hidden="true" />
          </template>
        </van-field>

        <van-field
          v-model="password"
          :type="passwordType"
          class="auth-field"
          autocomplete="new-password"
          :placeholder="$t('auth.pwd_place')"
        >
          <template #left-icon>
            <van-icon name="lock" aria-hidden="true" />
          </template>
          <template #right-icon>
            <van-icon
              :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
              aria-label="Toggle password visibility"
              @click="switchPasswordType"
            />
          </template>
        </van-field>

        <van-field
          v-model="code"
          clearable
          class="auth-field"
          autocomplete="off"
          :placeholder="$t('auth.invite_code_place')"
        >
          <template #left-icon>
            <van-icon name="envelop-o" aria-hidden="true" />
          </template>
        </van-field>

        <label class="agreement">
          <van-checkbox v-model="checked" shape="square" />
          <span class="agreement-text">{{$t("auth.agreement_place")}}</span>
        </label>

        <van-button class="auth-submit" type="primary" size="normal" @click="doRegister()">
          {{$t("auth.register")}}
        </van-button>
      </section>
    </main>
  </div>
</template>

<script>
import VictoriaBrand from '../../common/VictoriaBrand'

export default {
  components: {
    VictoriaBrand
  },
  model: {
    prop: 'inputValue',
    event: 'input'
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      checked: true,
      username: '',
      code: '',
      lang: 'en_us',
      password: this.inputValue,
      passwordType: 'password',
    };
  },
  mounted(){
    this.lang = localStorage.getItem("lang") || 'th_th';
  },
  methods: {
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    back(){
      return window.history.back();
    },
    doRegister() {
      if(this.username === "" || this.username === null || this.username === undefined){
        this.$toast.fail(this.$t("auth.username_place"));
        return false;
      }
      if(this.password === "" || this.password === null || this.password === undefined){
        this.$toast.fail(this.$t("auth.pwd_place"));
        return false;
      }
      if(this.code === "" || this.code === null || this.code === undefined){
        this.$toast.fail(this.$t("auth.invite_code_place"));
        return false;
      }
      if(!this.checked){
        this.$toast.fail(this.$t("auth.agreement"));
        return false;
      }
      this.$http({
        method: 'post',
        data:{
          username:this.username,
          password:this.password,
          code:this.code,
          lang: this.lang
        },
        url: 'member_register'
      }).then(res=>{
	console.log(res);
          if(res.code === 200){
            this.$toast.success(res.msg);
            localStorage.setItem('token',res.data)
            this.$router.push("Mine")
          }else {
            this.$toast.fail(res.msg);
          }
      })
    }
  },
  created() {
    if(localStorage.getItem('token')){
      return window.history.back();
    }
  }
};
</script>

<style lang='less' scoped>
.auth-page {
  position: relative;
  min-height: 100%;
  overflow-y: auto;
  background-image:
    linear-gradient(180deg, rgba(7, 6, 8, 0.16) 0%, rgba(8, 6, 9, 0.05) 56%, rgba(8, 6, 9, 0.48) 100%),
    url('/img/victoria/auth-bg.png');
  background-position: center bottom;
  background-repeat: no-repeat;
  background-size: cover;
  color: var(--victoria-text);
}

.auth-nav {
  background: transparent;
}

::v-deep .auth-nav::after {
  display: none;
}

::v-deep .auth-nav .van-nav-bar__title,
::v-deep .auth-nav .van-icon {
  color: var(--victoria-text) !important;
}

::v-deep .auth-nav .van-nav-bar__title {
  font-size: 0.4rem !important;
  font-weight: 500 !important;
  text-transform: capitalize;
}

.auth-content {
  display: flex;
  flex-direction: column;
  min-height: calc(100% - 1.22667rem);
  padding: 0 0.72rem calc(0.78rem + env(safe-area-inset-bottom));
}

.auth-form {
  display: grid;
  gap: 0.34rem;
  margin-top: 0.45rem;
}

.auth-field {
  --auth-field-height: 1.24rem;
  display: flex;
  height: var(--auth-field-height);
  min-height: 1.24rem;
  padding: 0 0.46rem;
  align-items: center;
  color: var(--victoria-text);
  background: rgba(20, 17, 21, 0.8);
  border: 1px solid rgba(231, 160, 174, 0.24);
  border-radius: 0.66rem;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.035), 0 0.18rem 0.5rem rgba(0, 0, 0, 0.18);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.auth-field:focus-within {
  border-color: rgba(255, 209, 217, 0.7);
  box-shadow: 0 0 0 0.08rem rgba(231, 160, 174, 0.12), 0 0.22rem 0.6rem rgba(0, 0, 0, 0.22);
}

::v-deep .auth-field::after {
  display: none;
}

::v-deep .auth-field .van-field__control {
  height: 100%;
  padding: 0;
  color: var(--victoria-text);
  font-size: 0.35rem;
  line-height: var(--auth-field-height);
}

::v-deep .auth-field .van-field__control::placeholder {
  color: rgba(248, 241, 243, 0.58);
}

::v-deep .auth-field .van-field__left-icon,
::v-deep .auth-field .van-field__right-icon {
  display: inline-flex;
  height: 100%;
  align-items: center;
  color: var(--victoria-primary);
  font-size: 0.49rem;
  line-height: normal;
}

::v-deep .auth-field .van-cell__value,
::v-deep .auth-field .van-field__body {
  height: 100%;
}

::v-deep .auth-field .van-field__body {
  align-items: center;
}

::v-deep .auth-field .van-field__clear {
  display: inline-flex;
  height: 100%;
  align-items: center;
}

::v-deep .victoria-brand__logo {
  border: 1px solid rgba(231, 160, 174, .66);
  border-radius: 50%;
  box-shadow: inset 0 0 .52rem rgba(231, 160, 174, .06), 0 0 .48rem rgba(231, 160, 174, .12);
}

.agreement {
  display: flex;
  align-items: flex-start;
  padding: 0.06rem 0.08rem;
}

.agreement-text {
  margin-left: 0.2rem;
  color: rgba(248, 241, 243, 0.8);
  font-size: 0.29rem;
  line-height: 1.45;
}

::v-deep .agreement .van-checkbox__icon {
  height: 0.48rem;
  font-size: 0.44rem;
  line-height: 0.48rem;
}

::v-deep .agreement .van-checkbox__icon .van-icon {
  color: transparent;
  background: rgba(20, 17, 21, 0.76);
  border-color: var(--victoria-muted-rose);
  border-radius: 0.08rem;
}

::v-deep .agreement .van-checkbox__icon--checked .van-icon {
  color: #2b191f;
  background: var(--victoria-primary);
  border-color: var(--victoria-light-rose);
}

.auth-submit {
  width: 100%;
  height: 1.34rem;
  margin-top: 0.06rem;
  color: #28191e;
  font-size: 0.37rem;
  font-weight: 700;
  letter-spacing: 0.06rem;
  text-transform: uppercase;
  background: var(--victoria-action);
  border: 0;
  border-radius: 0.7rem;
  box-shadow: 0 0.25rem 0.7rem rgba(207, 127, 145, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.32);
}

@media (max-height: 720px) {
  .auth-content {
    padding-top: 0;
  }

  .auth-form {
    gap: 0.26rem;
    margin-top: 0.22rem;
  }

  .auth-field {
    --auth-field-height: 1.14rem;
    height: var(--auth-field-height);
    min-height: 1.14rem;
  }
}
</style>
